import script from "./UTable.vue?vue&type=script&setup=true&lang=js"
export * from "./UTable.vue?vue&type=script&setup=true&lang=js"

import "./UTable.vue?vue&type=style&index=0&id=5f856e48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f856e48"]])

export default __exports__